{
  "nm": "Comp 1",
  "ddd": 0,
  "h": 70,
  "w": 70,
  "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" },
  "layers": [
    {
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "st": 0,
      "op": 450.000018328876,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [0, 0, 100],
              "t": 33
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [120, 120, 100],
              "t": 46
            },
            { "s": [100, 100, 100], "t": 52.0000021180034 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [35, 35, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Shape 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7, 1.438],
                    [-2.656, 5.781],
                    [7.422, -4.297]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 2,
              "ml": 1,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3, "ix": 5 },
              "c": { "a": 0, "k": [1, 1, 1], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.333, "y": 0 },
                "i": { "x": 0.667, "y": 1 },
                "s": [0],
                "t": 33
              },
              { "s": [100], "t": 52.0000021180034 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "s": { "a": 0, "k": 0, "ix": 1 },
          "m": 1
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "st": 0,
      "op": 450.000018328876,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [0, 0, 100],
              "t": 18
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [120, 120, 100],
              "t": 33
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [80, 80, 100],
              "t": 41
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [110, 110, 100],
              "t": 49
            },
            { "s": [100, 100, 100], "t": 52.0000021180034 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [35, 35, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [13.015, 0],
                    [0, -13.015],
                    [-13.015, 0],
                    [0, 13.015]
                  ],
                  "o": [
                    [-13.015, 0],
                    [0, 13.015],
                    [13.015, 0],
                    [0, -13.015]
                  ],
                  "v": [
                    [0, -23.566],
                    [-23.566, 0],
                    [0, 23.566],
                    [23.566, 0]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "c": { "a": 0, "k": [0.898, 0.898, 0.898], "ix": 3 }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.5451, 0.7647, 0.2902], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [105.535, 105.535], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 2
    }
  ],
  "v": "4.11.1",
  "fr": 29.9700012207031,
  "op": 76.0000030955435,
  "ip": 0,
  "assets": []
}
